var map = {
	"./ai-brain.png": 1687,
	"./analysis.png": 3452,
	"./chart.png": 1716,
	"./cloud-done.png": 8514,
	"./inventory.png": 7372,
	"./lock.png": 2487,
	"./microservices.png": 7584,
	"./software-license.png": 8671,
	"./trend-down.png": 1876,
	"./vector.png": 1979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9856;